import { validatePlatformFields } from '../../../utils';

export type FormValues = {
  [key: string]: string | null;
  client_id: string | null;
  client_secret: string | null;
};
type PlatformFormErrors = {
  client_id?: string;
  client_secret?: string;
};

export const platformSettingsValidator =
  (platformName: string) =>
  (values: FormValues): PlatformFormErrors => {
    const error: PlatformFormErrors = {};

    if (platformName === 'xbox') {
      return error;
    }

    if (!values.client_id) {
      error.client_id = 'app.validation.required';
    }
    if (!values.client_secret) {
      error.client_secret = 'app.validation.required';
    }

    if (!validatePlatformFields(values.client_id)) {
      error.client_id = 'app.validation.value-invalid';
    }
    if (!validatePlatformFields(values.client_secret)) {
      error.client_secret = 'app.validation.value-invalid';
    }

    return error;
  };
